// src/hooks/useEventData.js

import { useState, useEffect } from 'react';

// 🚨 Ensure this path matches your Node BFF endpoint setup

const API_BASE = process.env.REACT_APP_API_BASE_URL;
const API_URL = `${API_BASE}/api/event/techsummit`; 
const useEventData = () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchEventData = async () => {
            try {
                const response = await fetch(API_URL);
                
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                
                const eventData = await response.json();
                
                // The BFF ensures this object matches the structure of your old data.js
                setData(eventData);
            } catch (err) {
                console.error("Failed to fetch event data:", err);
                setError(err.message || "An unknown error occurred while fetching data.");
            } finally {
                setLoading(false);
            }
        };

        fetchEventData();
    }, []); 

    // Return the state for the component to use
    return { data, loading, error };
};

export default useEventData;